import { Component, OnInit, Input } from '@angular/core';
import { DadosService } from '../../db/dados.service'

@Component({
    selector: 'titulo-fornecedor',
    templateUrl: 'titulo.fornecedor.html',
    styleUrls:[ 'titulo.fornecedor.css' ]
})

export class TituloFornecedorComponent implements OnInit {
    fCodigo: number = 0;
    fornecedor: any = null;
    @Input()
    get codigo():number {
        return this.fCodigo;
    }
    set codigo(x: number) {
        this.fornecedor = this.getFornecedor(x);

    }
    getFornecedor(x: number) {
        if (x != null) {
            this.fCodigo = x;
            this.fornecedor = this.dados.getFornecedor(x);
        }
        return this.fornecedor;
    }
    constructor(private dados: DadosService) { }

    ngOnInit() { }
}